import {
  Dialog,
  DialogContent,
  DialogActions,
  Typography,
  Button,
} from '@mui/material';
import RouteMessage from '../../components/RouteMessage/RouteMessage';

export default function ApiResponseModal({
  isOpen,
  title,
  message,
  handleClose,
}) {
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogContent>
        {title && (
          <Typography
            variant="h1"
            style={{ whiteSpace: 'pre-wrap', textAlign: 'center' }}
          >
            {title}
          </Typography>
        )}
        <RouteMessage message={message} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
